export default globalThis;

export const hasWindow = ((): boolean => 'window' in globalThis)();
